/**
 * RBAC module slug is `chat` (UI label: Messages / Message Management).
 */
export const CHAT_MODULE_KEY = "chat";

/** Open Messages menu / read conversations (not create/initiate). */
export const CHAT_VIEW_PERMISSIONS = [
  "chat.access",
  "chat.community_view",
  "chat.broadcast_view",
];

export const CHAT_ONE_TO_ONE_PERMISSION = "chat.one_to_one";
export const CHAT_GROUP_PERMISSION = "chat.group";

export const CHAT_MENU_PERMISSIONS = [
  ...CHAT_VIEW_PERMISSIONS,
  CHAT_ONE_TO_ONE_PERMISSION,
  CHAT_GROUP_PERMISSION,
  "chat.group.create_class",
  "chat.group.create_department",
  "chat.group.create_institute",
  "chat.broadcast.create_department",
  "chat.broadcast.create_institute",
];
